import axios from '@/plugins/axios';

export function aliyun() {
  return axios.get('/temporary/aliyun');
}
